import {Store} from '@gongxigames/framework/core/fragments/store/Store';

export const JurisdictionZoneDataStore = Store.createStore({
    jurisdictionData_gameName_enabled: Store.signal(false),
    jurisdictionData_gameName: Store.signal(''),

    jurisdictionData_pointsBalance_enabled: Store.signal(false),
    jurisdictionData_pointsBalance: Store.signal(''),

    jurisdictionData_clock_enabled: Store.signal(false),
    jurisdictionData_clock: Store.signal('00:00'),

    jurisdictionData_netPosition_enabled: Store.signal(false),
    jurisdictionData_netPosition: Store.signal(''),

    jurisdictionData_elapsedTime_enabled: Store.signal(false),
    jurisdictionData_elapsedTime: Store.signal(''),

    jurisdictionData_sessionEarnings_enabled: Store.signal(false),
    jurisdictionData_sessionEarnings: Store.signal(''),

    jurisdictionData_sessionBets_enabled: Store.signal(false),
    jurisdictionData_sessionBets: Store.signal(''),

    jurisdictionData_showMaxWinProbability_enabled: Store.signal(false),
    jurisdictionData_showMaxWinProbability: Store.signal(''),

    jurisdictionData_RTPWatermark_enabled: Store.signal(false),
    jurisdictionData_RTPWatermark: Store.signal(0),
});